module.exports = __webpack_public_path__ + "static/media/Person.b88de450.svg";